var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 19407"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 115",
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#3FBF62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.84632 4.93563L5.89685 7.88905L4.71903 6.70747L4.71905 6.70745L4.71701 6.70548C4.66325 6.65355 4.59978 6.61271 4.53024 6.58531C4.4607 6.5579 4.38644 6.54446 4.3117 6.54575C4.23696 6.54705 4.16321 6.56305 4.09466 6.59284C4.0261 6.62264 3.96409 6.66565 3.91216 6.71941C3.86022 6.77317 3.81939 6.83663 3.79198 6.90618C3.76458 6.97572 3.75114 7.04998 3.75243 7.12472C3.75372 7.19946 3.76972 7.27321 3.79952 7.34176C3.82913 7.40989 3.87178 7.47155 3.92508 7.52329L5.499 9.09721C5.49908 9.09729 5.49916 9.09737 5.49924 9.09745C5.55127 9.14984 5.61314 9.19144 5.68131 9.21984C5.74958 9.24828 5.8228 9.26292 5.89675 9.26292C5.97071 9.26292 6.04393 9.24828 6.1122 9.21984C6.18035 9.19144 6.24222 9.14985 6.29425 9.09747C6.29433 9.09738 6.29442 9.0973 6.2945 9.09721L9.63942 5.7523C9.69516 5.70027 9.73971 5.6374 9.77031 5.56753L9.63291 5.50734L9.77031 5.56753C9.80135 5.49666 9.81737 5.42013 9.81737 5.34277C9.81737 5.2654 9.80135 5.18887 9.77031 5.11801L9.63291 5.17819L9.77031 5.11801C9.73971 5.04816 9.69519 4.9853 9.63946 4.93327C9.58787 4.88188 9.52675 4.84102 9.45951 4.81301C9.39124 4.78456 9.31802 4.76992 9.24407 4.76992C9.17011 4.76992 9.09689 4.78456 9.02862 4.81301C8.96046 4.8414 8.8986 4.88299 8.84657 4.93538C8.84649 4.93546 8.8464 4.93555 8.84632 4.93563Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.3d9d6f46be1dd47677f00791798d8578.svg";
export { ForwardRef as ReactComponent };